export const SPECIALDAY = "SPECIALDAY";
export const SPECIALDAY_SUCCESS = "SPECIALDAY_SUCCESS";
export const SPECIALDAY_FAILED = "SPECIALDAY_FAILED";

export const ADD_SPECIALDAY = "ADD_SPECIALDAY";
export const ADD_SPECIALDAY_SUCCESS = "ADD_SPECIALDAY_SUCCESS";
export const ADD_SPECIALDAY_FAILED = "ADD_SPECIALDAY_FAILED";

export const UPDATE_SPECIALDAY = "UPDATE_SPECIALDAY";
export const UPDATE_SPECIALDAY_SUCCESS = "UPDATE_SPECIALDAY_SUCCESS";
export const UPDATE_SPECIALDAY_FAILED = "UPDATE_SPECIALDAY_FAILED";